module.exports = __webpack_public_path__ + "img/purchase.edc95ba4.png";